import SETTINGS from '../../public/locales/en/settings';
import COMMON from '../../public/locales/en/common';
import DASHBOARD from '../../public/locales/en/dashboard';
import NEW_DASHBOARD from '../../public/locales/en/newDashboard';
import CSM_SERVICE from '../../public/locales/ko/csmService';
import EMAIL_VERIFY from '../../public/locales/en/email_verify';
import FOOTER from '../../public/locales/en/footer';
import FORGOT from '../../public/locales/en/forgot';
import HELP from '../../public/locales/en/help';
import JOIN from '../../public/locales/en/join';
import LAUNCHED from '../../public/locales/en/launched';
import LOGIN from '../../public/locales/en/login';
import MY_CAMPAIGNS from '../../public/locales/en/my_campaigns';
import PROPOSAL from '../../public/locales/en/proposal';
import RESET from '../../public/locales/en/reset';
import NOT_FOUND from '../../public/locales/en/not_found';
import BILLING_HISTORY from '../../public/locales/en/billing_history';
import EXPRESS from '../../public/locales/en/express';
import ONBOARDING from '../../public/locales/en/onboarding';
import VAT from '../../public/locales/en/vat';
import IMAGE_TEMPLATE from '../../public/locales/en/image_template';
import { locale } from 'adriel_backandfrontcommon';
import CONNECTION from '../../public/locales/en/connection';
import STRATEGY from '../../public/locales/en/strategy';
import PAYMENT from '../../public/locales/en/payment';
import MULTI_ACCOUNT from '../../public/locales/en/multi_account';
import REMARKETING from '../../public/locales/en/remarketing';
import OBJECTIVE from '../../public/locales/en/objective';
import EDITABLE_DASHBOARD from '../../public/locales/en/editableDashboard';
import TOAST from '../../public/locales/en/toast';
import WIDGET from '../../public/locales/en/widget';
import CREATIVE from '../../public/locales/en/creativePanel';
import DIMENSIONS from '../../public/locales/en/dimensions';
import FILTERS from '../../public/locales/en/filters';
import CUSTOM_METRIC from '../../public/locales/en/customMetric';
import PRINTPDF from '../../public/locales/en/printpdf';
import EXPORT_DATA from '../../public/locales/en/export_data';
import METRICS from '../../public/locales/en/metrics';
import TERMS_AND_POLICY from '../../public/locales/ko/terms_and_policy';
import UPGRADE_PLAN from '../../public/locales/en/upgradePlan';
import WIDGET_STYLES from '../../public/locales/en/widgetStyles';
import CHANNEL from '../../public/locales/en/channel';
import AUTOMATION from '../../public/locales/en/automation';
import API_CENTER from '../../public/locales/en/api_center';
import NAVIGATION from '../../public/locales/en/navigation';
import FIELD_PANEL from '../../public/locales/en/field_panel';

export default {
    PRINTPDF,
    SETTINGS,
    BILLING_HISTORY,
    COMMON,
    DASHBOARD,
    NEW_DASHBOARD,
    CSM_SERVICE,
    EMAIL_VERIFY,
    FOOTER,
    FORGOT,
    HELP,
    JOIN,
    LAUNCHED,
    LOGIN,
    MY_CAMPAIGNS,
    NOT_FOUND,
    PROPOSAL,
    RESET,
    EXPRESS,
    ONBOARDING,
    VAT,
    MANAGER: {
        ...locale.optimizer,
        ...locale.connectActionsRequiredMessages,
    },
    IMAGE_TEMPLATE,
    CONNECTION,
    STRATEGY,
    PAYMENT,
    MULTI_ACCOUNT,
    REMARKETING,
    OBJECTIVE,
    EDITABLE_DASHBOARD,
    TOAST,
    WIDGET,
    METRICS,
    CREATIVE,
    DIMENSIONS,
    FILTERS,
    CUSTOM_METRIC,
    EXPORT_DATA,
    TERMS_AND_POLICY,
    UPGRADE_PLAN,
    WIDGET_STYLES,
    CHANNEL,
    AUTOMATION,
    API_CENTER,
    NAVIGATION,
    FIELD_PANEL,
};
